var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSylized5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0429688 10.9046C0.0429688 4.88216 4.92485 3.24249e-05 10.9479 3.24249e-05C16.9696 3.24249e-05 21.8515 4.88216 21.8515 10.9046C21.8515 16.9269 16.9696 21.809 10.9479 21.809C4.92485 21.809 0.0429688 16.9269 0.0429688 10.9046Z",
    fill: "#F6DE4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73457 8.87557C7.73457 9.62346 7.3738 10.2299 6.92987 10.2299C6.48723 10.2299 6.12646 9.62346 6.12646 8.87557C6.12646 8.12768 6.48723 7.52116 6.92987 7.52116C7.3738 7.52116 7.73457 8.12768 7.73457 8.87557Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7685 8.87557C15.7685 9.62346 15.409 10.2299 14.965 10.2299C14.5211 10.2299 14.1616 9.62346 14.1616 8.87557C14.1616 8.12768 14.5211 7.52116 14.965 7.52116C15.409 7.52116 15.7685 8.12768 15.7685 8.87557Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.543 14.3751C12.043 15.8751 9.54297 15.8751 8.04297 14.3751",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSylized5);
export default __webpack_public_path__ + "static/media/sylized_5.e3f2c0adb5ee587e7a91a3112289b7aa.svg";
export { ForwardRef as ReactComponent };